import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router, Route, Redirect, browserHistory } from 'react-router';
import { I18nextProvider } from 'react-i18next';
import { AppContainer } from 'react-hot-loader'; // eslint-disable-line

import i18n from '../../i18n';

import App from './../App';
// import RootSelection from '../../containers/RootSelection/RootSelection';
import MainPage from './../../components/MainPage';
import LoadingError from './../../components/LoadingError';

const Root = ({ store }) => (
  <AppContainer>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router history={browserHistory}>
          <Redirect from="/" to="ajanvaraus" />
          <Route path="/" component={App}>
            <Route path="ajanvaraus" component={MainPage} />
            <Route path="tiketti" component={MainPage} goTo={'byTicket'} />
            <Route path="error" component={params => <LoadingError routingParams={params} />} />
          </Route>
        </Router>
      </Provider>
    </I18nextProvider>
  </AppContainer>
);

Root.propTypes = {
  store: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root/index.jsx